import {combineReducers} from 'redux';

import {CustArrived} from './CustArrived.reducer';

export const interactive = combineReducers({
    CustArrived,
});
